// extracted by mini-css-extract-plugin
export default {"searchButton":"registration_searchButton__qitsf","resendButton":"registration_resendButton__bN9g7"};